<span class="example-pizza-party" matSnackBarLabel>
  {{ data }}
</span>
<span matSnackBarActions>
  <button mat-icon-button class="close" (click)="snackBarRef.dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</span>
